import analysis from "../models/analysis";

export const types = {
  KYC_FETCH_REQUEST: 'KYC_FETCH_REQUEST',
  KYC_FETCH_SUCCESS: 'KYC_FETCH_SUCCESS',
  KYC_SOURCE_CHANGED_REQEUEST: 'KYC_SOURCE_CHANGED_REQEUEST',
  KYC_SOURCE_CHANGED_SUCCESS: 'KYC_SOURCE_CHANGED_SUCCESS',
  KYC_GET_WIDGET_REQUEST: 'KYC_GET_WIDGET_REQUEST',
  KYC_GET_WIDGET_SUCCESS: 'KYC_GET_WIDGET_SUCCESS',
  KYC_FETCH_FAILED: 'KYC_FETCH_FAILED',
  KYC_CLEAR_COMPONENT: 'KYC_CLEAR_COMPONENT',
  SCL_FETCH_REQUEST: 'SCL_FETCH_REQUEST',
  SCL_FETCH_SUCCESS: 'SCL_FETCH_SUCCESS',
  SCL_SOURCE_CHANGED_REQEUEST: 'SCL_SOURCE_CHANGED_REQEUEST',
  SCL_SOURCE_CHANGED_SUCCESS: 'SCL_SOURCE_CHANGED_SUCCESS',
  SCL_GET_WIDGET_REQUEST: 'SCL_GET_WIDGET_REQUEST',
  SCL_GET_WIDGET_SUCCESS: 'SCL_GET_WIDGET_SUCCESS',
  SCL_FETCH_FAILED: 'SCL_FETCH_FAILED',
  SCL_CLEAR_COMPONENT: 'SCL_CLEAR_COMPONENT',
  SCP_FETCH_REQUEST: 'SCP_FETCH_REQUEST',
  SCP_FETCH_SUCCESS: 'SCP_FETCH_SUCCESS',
  SCP_SOURCE_CHANGED_REQEUEST: 'SCP_SOURCE_CHANGED_REQEUEST',
  SCP_SOURCE_CHANGED_SUCCESS: 'SCP_SOURCE_CHANGED_SUCCESS',
  SCP_GET_WIDGET_REQUEST: 'SCP_GET_WIDGET_REQUEST',
  SCP_GET_WIDGET_SUCCESS: 'SCP_GET_WIDGET_SUCCESS',
  SCP_FETCH_FAILED: 'SCP_FETCH_FAILED',
  SCP_CLEAR_COMPONENT: 'SCP_CLEAR_COMPONENT',
  DD_FETCH_REQUEST: 'DD_FETCH_REQUEST',
  DD_FETCH_SUCCESS: 'DD_FETCH_SUCCESS',
  DD_SOURCE_CHANGED_REQEUEST: 'DD_SOURCE_CHANGED_REQEUEST',
  DD_SOURCE_CHANGED_SUCCESS: 'DD_SOURCE_CHANGED_SUCCESS',
  DD_GET_WIDGET_REQUEST: 'DD_GET_WIDGET_REQUEST',
  DD_GET_WIDGET_SUCCESS: 'DD_GET_WIDGET_SUCCESS',
  DD_FETCH_FAILED: 'DD_FETCH_FAILED',
  DD_CLEAR_COMPONENT: 'DD_CLEAR_COMPONENT',
  MINE_OPERATORS_FETCH_REQUEST: 'MINE_OPERATORS_FETCH_REQUEST',
  MINE_OPERATORS_FETCH_SUCCESS: 'MINE_OPERATORS_FETCH_SUCCESS',
  MINE_OPERATORS_SOURCE_CHANGED_REQEUEST: 'MINE_OPERATORS_SOURCE_CHANGED_REQEUEST',
  MINE_OPERATORS_SOURCE_CHANGED_SUCCESS: 'MINE_OPERATORS_SOURCE_CHANGED_SUCCESS',
  MINE_OPERATORS_GET_WIDGET_REQUEST: 'MINE_OPERATORS_GET_WIDGET_REQUEST',
  MINE_OPERATORS_GET_WIDGET_SUCCESS: 'MINE_OPERATORS_GET_WIDGET_SUCCESS',
  MINE_OPERATORS_FETCH_FAILED: 'MINE_OPERATORS_FETCH_FAILED',
  MINE_OPERATORS_CLEAR_COMPONENT: 'MINE_OPERATORS_CLEAR_COMPONENT',
  AMP_FETCH_REQUEST: 'AMP_FETCH_REQUEST',
  AMP_FETCH_SUCCESS: 'AMP_FETCH_SUCCESS',
  AMP_SOURCE_CHANGED_REQEUEST: 'AMP_SOURCE_CHANGED_REQEUEST',
  AMP_SOURCE_CHANGED_SUCCESS: 'AMP_SOURCE_CHANGED_SUCCESS',
  AMP_GET_WIDGET_REQUEST: 'AMP_GET_WIDGET_REQUEST',
  AMP_GET_WIDGET_SUCCESS: 'AMP_GET_WIDGET_SUCCESS',
  AMP_FETCH_FAILED: 'AMP_FETCH_FAILED',
  AMP_CLEAR_COMPONENT: 'AMP_CLEAR_COMPONENT',
  PROGRAMS_FETCH_REQUEST: 'PROGRAMS_FETCH_REQUEST',
  PROGRAMS_FETCH_SUCCESS: 'PROGRAMS_FETCH_SUCCESS',
  PROGRAMS_SOURCE_CHANGED_REQEUEST: 'PROGRAMS_SOURCE_CHANGED_REQEUEST',
  PROGRAMS_SOURCE_CHANGED_SUCCESS: 'PROGRAMS_SOURCE_CHANGED_SUCCESS',
  PROGRAMS_GET_WIDGET_REQUEST: 'PROGRAMS_GET_WIDGET_REQUEST',
  PROGRAMS_GET_WIDGET_SUCCESS: 'PROGRAMS_GET_WIDGET_SUCCESS',
  PROGRAMS_FETCH_FAILED: 'PROGRAMS_FETCH_FAILED',
  PROGRAMS_CLEAR_COMPONENT: 'PROGRAMS_CLEAR_COMPONENT',
};

export const actions = {
  KycFetchRequest: (value) => ({
    type: types.KYC_FETCH_REQUEST,
    value,
  }),
  KycClearComponent: () => ({
    type: types.KYC_CLEAR_COMPONENT,
  }),
  ScpFetchReqeust: (value) => ({
    type: types.SCP_FETCH_REQUEST,
    value,
  }),
  ScpFetchWidget: (value, { widget, options }) => {
    return {
      type: types.SCP_GET_WIDGET_REQUEST,
      value: { ...value, widget, options },
    }
  },
  ScpSourcesChanged: (value) => ({
    type: types.SCP_SOURCE_CHANGED_REQEUEST,
    value,
  }),
  ScpClearComponent: () => ({
    type: types.SCP_CLEAR_COMPONENT,
  }),
  DdFetchReqeust: (value) => ({
    type: types.DD_FETCH_REQUEST,
    value,
  }),
  DdFetchWidget: (value, { widget, options }) => ({
    type: types.DD_GET_WIDGET_REQUEST,
    value: { widget, options, ...value },
  }),
  DdClearComponent: () => ({
    type: types.DD_CLEAR_COMPONENT,
  }),
  SclFetchRequest: (value) => ({
    type: types.SCL_FETCH_REQUEST,
    value,
  }),
  SclClearComponent: () => ({
    type: types.SCL_CLEAR_COMPONENT,
  }),
  SclSourcesChanged: (value) => ({
    type: types.SCL_SOURCE_CHANGED_REQEUEST,
    value,
  }),
  MineOperatorsFetchReqeust: (value) => ({
    type: types.MINE_OPERATORS_FETCH_REQUEST,
    value,
  }),
  MineOperatorsFetchWidget: (value, { widget, options }) => {
    return {
      type: types.MINE_OPERATORS_GET_WIDGET_REQUEST,
      value: { ...value, widget, options },
    }
  },
  MineOperatorsSourcesChanged: (value) => ({
    type: types.MINE_OPERATORS_SOURCE_CHANGED_REQEUEST,
    value,
  }),
  MineOperatorsClearComponent: () => ({
    type: types.AMP_CLEAR_COMPONENT,
  }),
  AmpFetchReqeust: (value) => ({
    type: types.AMP_FETCH_REQUEST,
    value,
  }),
  AmpFetchWidget: (value, { widget, options }) => {
    return {
      type: types.AMP_GET_WIDGET_REQUEST,
      value: { ...value, widget, options },
    }
  },
  AmpSourcesChanged: (value) => ({
    type: types.AMP_SOURCE_CHANGED_REQEUEST,
    value,
  }),
  AmpClearComponent: () => ({
    type: types.AMP_CLEAR_COMPONENT,
  }),
  ProgramsFetchReqeust: (value) => ({
    type: types.PROGRAMS_FETCH_REQUEST,
    value,
  }),
  ProgramsFetchWidget: (value, { widget, options }) => {
    return {
      type: types.PROGRAMS_GET_WIDGET_REQUEST,
      value: { ...value, widget, options },
    }
  },
  ProgramsSourcesChanged: (value) => ({
    type: types.PROGRAMS_SOURCE_CHANGED_REQEUEST,
    value,
  }),
  ProgramsClearComponent: () => ({
    type: types.PROGRAMS_CLEAR_COMPONENT,
  }),
};

export default function reducer(state = analysis, action) {
  switch (action.type) {
    case types.SCP_FETCH_REQUEST:
      return {
        ...state,
        scp: {
          loading: true,
          retrieved: false,
          sources: null,
          widgets: null,
        },
      }
    case types.SCP_FETCH_FAILED:
      return {
        ...state,
        scp: {
          ...state.scp,
          error: true,
        },
      }
    case types.SCP_FETCH_SUCCESS:
      return {
        ...state,
        scp: {
          loading: false,
          retrieved: true,
          sources: action.sources,
          widgets: action.widgets,
          options: action.options,
        }
      };
    case types.SCP_GET_WIDGET_REQUEST:
      return {
        ...state,
        scp: {
          ...state.scp,
          widgets: {
            ...state.scp.widgets,
            [action.value.widget]: null,
          }
        }
      }
    case types.SCP_GET_WIDGET_SUCCESS:
      return {
        ...state,
        scp: {
          ...state.scp,
          widgets: {
            ...state.scp.widgets,
            [action.widget]: action.data,
          }
        }
      }
    case types.SCP_SOURCE_CHANGED_REQEUEST:
      return {
        ...state,
        scp: {
          ...state.scp,
          loading: true,
        },
      };
    case types.SCP_SOURCE_CHANGED_SUCCESS:
      return {
        ...state,
        scp: {
          ...state.scp,
          loading: false,
          widgets: action.widgets,
        }
      };
    case types.SCP_CLEAR_COMPONENT:
      return {
        ...state,
        scp: analysis.scp,
      };
    case types.DD_FETCH_REQUEST:
      return {
        ...state,
        dd: {
          loading: true,
          retrieved: false,
          sources: null,
          widgets: null,
        },
      }
    case types.DD_FETCH_FAILED:
      return {
        ...state,
        dd: {
          ...state.dd,
          error: true,
        },
      }
    case types.DD_FETCH_SUCCESS:
      return {
        ...state,
        dd: {
          loading: false,
          retrieved: true,
          sources: action.sources,
          widgets: action.widgets,
          options: action.options,
        }
      };
    case types.DD_GET_WIDGET_REQUEST:
      return {
        ...state,
        dd: {
          ...state.dd,
          widgets: {
            ...state.dd.widgets,
            [action.value.widget]: null,
          }
        }
      }
    case types.DD_GET_WIDGET_SUCCESS:
      return {
        ...state,
        dd: {
          ...state.dd,
          widgets: {
            ...state.dd.widgets,
            [action.widget]: action.data,
          }
        }
      }
    case types.DD_CLEAR_COMPONENT:
      return {
        ...state,
        dd: analysis.dd,
      };
    case types.KYC_FETCH_REQUEST:
      return {
        ...state,
        kyc: {
          loading: true,
          retrieved: false,
          sources: null,
          widgets: null,
        },
      }
    case types.KYC_FETCH_FAILED:
      return {
        ...state,
        kyc: {
          ...state.kyc,
          error: true,
        },
      }
    case types.KYC_FETCH_SUCCESS:
      return {
        ...state,
        kyc: {
          loading: false,
          retrieved: true,
          sources: action.sources,
          widgets: action.widgets,
          options: action.options,
        }
      };
    case types.KYC_GET_WIDGET_REQUEST:
      return {
        ...state,
        kyc: {
          ...state.kyc,
          widgets: {
            ...state.kyc.widgets,
            [action.value.widget]: null,
          }
        }
      }
    case types.KYC_GET_WIDGET_SUCCESS:
      return {
        ...state,
        kyc: {
          ...state.kyc,
          widgets: {
            ...state.kyc.widgets,
            [action.widget]: action.data,
          }
        }
      }
    case types.KYC_CLEAR_COMPONENT:
      return {
        ...state,
        kyc: analysis.kyc,
      };
    case types.SCL_FETCH_REQUEST:
      return {
        ...state,
        scl: {
          loading: true,
          retrieved: false,
          sources: null,
          widgets: null,
        },
      }
    case types.SCL_FETCH_FAILED:
      return {
        ...state,
        scl: {
          ...state.scl,
          error: true,
        },
      }
    case types.SCL_FETCH_SUCCESS:
      return {
        ...state,
        scl: {
          loading: false,
          retrieved: true,
          sources: action.sources,
          widgets: action.widgets,
          options: action.options,
        }
      };
    case types.SCL_GET_WIDGET_REQUEST:
      return {
        ...state,
        scl: {
          ...state.scl,
          widgets: {
            ...state.scl.widgets,
            [action.value.widget]: null,
          }
        }
      }
    case types.SCL_GET_WIDGET_SUCCESS:
      return {
        ...state,
        scl: {
          ...state.scl,
          widgets: {
            ...state.scl.widgets,
            [action.widget]: action.data,
          }
        }
      }
    case types.SCL_SOURCE_CHANGED_REQEUEST:
      return {
        ...state,
        scl: {
          ...state.scl,
          loading: true,
        },
      };
    case types.SCL_SOURCE_CHANGED_SUCCESS:
      return {
        ...state,
        scl: {
          ...state.scl,
          loading: false,
          widgets: action.widgets,
        }
      };
    case types.SCL_CLEAR_COMPONENT:
      return {
        ...state,
        scl: analysis.scl,
      }
    case types.MINE_OPERATORS_FETCH_REQUEST:
      return {
        ...state,
        'mine-operators': {
          loading: true,
          retrieved: false,
          sources: null,
          widgets: null,
        },
      }
    case types.MINE_OPERATORS_FETCH_FAILED:
      return {
        ...state,
        'mine-operators': {
          ...state['mine-operators'],
          error: true,
        },
      }
    case types.MINE_OPERATORS_FETCH_SUCCESS:
      return {
        ...state,
        'mine-operators': {
          loading: false,
          retrieved: true,
          sources: action.sources,
          widgets: action.widgets,
          options: action.options,
        }
      };
    case types.MINE_OPERATORS_GET_WIDGET_REQUEST:
      return {
        ...state,
        'mine-operators': {
          ...state['mine-operators'],
          widgets: {
            ...state['mine-operators'].widgets,
            [action.value.widget]: null,
          }
        }
      }
    case types.MINE_OPERATORS_GET_WIDGET_SUCCESS:
      return {
        ...state,
        'mine-operators': {
          ...state['mine-operators'],
          widgets: {
            ...state['mine-operators'].widgets,
            [action.widget]: action.data,
          }
        }
      }
    case types.MINE_OPERATORS_SOURCE_CHANGED_REQEUEST:
      return {
        ...state,
        'mine-operators': {
          ...state['mine-operators'],
          loading: true,
        },
      };
    case types.MINE_OPERATORS_SOURCE_CHANGED_SUCCESS:
      return {
        ...state,
        'mine-operators': {
          ...state['mine-operators'],
          loading: false,
          widgets: action.widgets,
        }
      };
    case types.MINE_OPERATORS_CLEAR_COMPONENT:
      return {
        ...state,
        'mine-operators': analysis['mine-operators'],
      };

    case types.AMP_FETCH_REQUEST:
      return {
        ...state,
        amp: {
          loading: true,
          retrieved: false,
          sources: null,
          widgets: null,
        },
      }
    case types.AMP_FETCH_FAILED:
      return {
        ...state,
        amp: {
          ...state.amp,
          error: true,
        },
      }
    case types.AMP_FETCH_SUCCESS:
      return {
        ...state,
        amp: {
          loading: false,
          retrieved: true,
          sources: action.sources,
          widgets: action.widgets,
          options: action.options,
        }
      };
    case types.AMP_GET_WIDGET_REQUEST:
      return {
        ...state,
        amp: {
          ...state.amp,
          widgets: {
            ...state.amp.widgets,
            [action.value.widget]: null,
          }
        }
      }
    case types.AMP_GET_WIDGET_SUCCESS:
      return {
        ...state,
        amp: {
          ...state.amp,
          widgets: {
            ...state.amp.widgets,
            [action.widget]: action.data,
          }
        }
      }
    case types.AMP_SOURCE_CHANGED_REQEUEST:
      return {
        ...state,
        amp: {
          ...state.amp,
          loading: true,
        },
      };
    case types.AMP_SOURCE_CHANGED_SUCCESS:
      return {
        ...state,
        amp: {
          ...state.amp,
          loading: false,
          widgets: action.widgets,
        }
      };
    case types.AMP_CLEAR_COMPONENT:
      return {
        ...state,
        amp: analysis.amp,
      };

    case types.PROGRAMS_FETCH_REQUEST:
      return {
        ...state,
        programs: {
          loading: true,
          retrieved: false,
          sources: null,
          widgets: null,
        },
      }
    case types.PROGRAMS_FETCH_FAILED:
      return {
        ...state,
        programs: {
          ...state.programs,
          error: true,
        },
      }
    case types.PROGRAMS_FETCH_SUCCESS:
      return {
        ...state,
        programs: {
          loading: false,
          retrieved: true,
          sources: action.sources,
          widgets: action.widgets,
          options: action.options,
        }
      };
    case types.PROGRAMS_GET_WIDGET_REQUEST:
      return {
        ...state,
        programs: {
          ...state.programs,
          widgets: {
            ...state.programs.widgets,
            [action.value.widget]: null,
          }
        }
      }
    case types.PROGRAMS_GET_WIDGET_SUCCESS:
      return {
        ...state,
        programs: {
          ...state.programs,
          widgets: {
            ...state.programs.widgets,
            [action.widget]: action.data,
          }
        }
      }
    case types.PROGRAMS_SOURCE_CHANGED_REQEUEST:
      return {
        ...state,
        programs: {
          ...state.programs,
          loading: true,
        },
      };
    case types.PROGRAMS_SOURCE_CHANGED_SUCCESS:
      return {
        ...state,
        programs: {
          ...state.programs,
          loading: false,
          widgets: action.widgets,
        }
      };
    case types.PROGRAMS_CLEAR_COMPONENT:
      return {
        ...state,
        programs: analysis.programs,
      };


    default:
      return state;
  }
};
